import {deserialize, deserializeAs, serialize, serializeAs} from "libs/cerialize";

export class TranslationModel {
	@deserialize
	LanguageId: number;

	@deserialize
	Value: string;
}